import script from "./TooltipContent.vue?vue&type=script&setup=true&lang=ts"
export * from "./TooltipContent.vue?vue&type=script&setup=true&lang=ts"

import "./TooltipContent.vue?vue&type=style&index=0&id=1ca10432&lang=css"

const __exports__ = script;

export default __exports__